import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async createArea({ commit }, payload) {
    return Vue.axios.post(Vue.$url("area"), payload).then((rsp) => {
      Vue.$log.debug("area created and saved under", rsp.data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Area", 1: payload.description }), { root: true });
    });
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug("loading area next code for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("area/max-code" + query)).then((rsp) => {
      commit("SET_NEXT_SEQ_CODE", rsp.data);
      return rsp.data;
    });
  },

  async fetchMaxValues({ commit }, { pId, vId }) {
    Vue.$log.debug("loading area next values for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("area/max-values" + query)).then((rsp) => {
      commit("SET_MAX_VALUES", rsp.data);
      return rsp.data;
    });
  },

  async fetchAreas({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug("loading areas for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "");

    return Vue.axios.get(Vue.$url("area" + query)).then((rsp) => {
      commit("SET_AREAS", rsp.data);
      return rsp.data;
    });
  },

  async deleteArea({ commit }, payload) {
    Vue.$log.debug("trying to delete Area", payload.id);
    return Vue.axios.delete(Vue.$url("area/" + payload.id)).then(() => commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }), { root: true }));
  },

  async updateArea({ commit }, payload) {
    return Vue.axios.put(Vue.$url("area/" + payload.id), payload).then(() => commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Area", 1: payload.description }), { root: true }));
  },

  async updateAreaList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`area/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
};
